import React, { use, useEffect } from "react";
import { QualificationForm } from "./Forms/QualificationForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOneQualificationQuery,
  useUpdateQualificationMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditQualification = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: qualificationResponse,
    isLoading,
    isFetching,
  } = useGetOneQualificationQuery({ id });
  const qualification = qualificationResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updateQualification, isPending } = useUpdateQualificationMutation(setError);

  const onSubmit = (data) => {
    updateQualification(data);
  };

  useEffect(() => {
    if (qualification) {
      reset(qualification);
    }
  }, [qualification]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_QUALIFICATION")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <QualificationForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_QUALIFICATION")}
                  </>
                ) : (
                  t("UPDATE_QUALIFICATION")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};
